import { Component, DestroyRef, OnInit, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ActivatedRoute } from "@angular/router";

@Component({
    selector: "app-related-services",
    templateUrl: "./related-services.component.html",
    styleUrls: ["./related-services.component.scss"],
})
export class RelatedServicesComponent implements OnInit {
    private destroyRef = inject(DestroyRef);
    constructor(private route: ActivatedRoute) {}

    ngOnInit(): void {
        this.route.data
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((data) => {
                switch (data.kind) {
                    case "kepler": {
                        this.singleSolutionsBox = [
                            {
                                icon: "/assets/img/funfacts/mdp-logo-removebg-preview.png",
                                title: "MDP",
                                imageClass: "",
                                paragraphText:
                                    "An integrated and modern data platform that centralizes and exposes key unconventional datasets to end users amplifies the business value and enables acceleration of critical decisions and insights through analytics.",
                                link: "platforms-mdp",
                                linkText: "View Details",
                            },
                            {
                                icon: "/assets/img/funfacts/UDA.png",
                                title: "UDA",
                                imageClass: "",
                                paragraphText:
                                    "The Upstream Digital Accelerator (UDA) Data Platform, or The LakeHouse, is a system of reference developed and designed to join disparate data sources and provide simplified access to upstream data for Western Canadian Heavy Oil assets.",
                                link: "platforms-uda",
                                linkText: "View Details",
                            },
                            {
                                icon: "/assets/img/funfacts/OSDU.png",
                                title: "OSDU",
                                imageClass: "",
                                paragraphText:
                                    "An industry-wide initiative to create a cloud-agnostic open subsurface environment. OSDU objectives are analogous to those of the Upstream Data Foundation (UDF) focused on surface and commercial data, whereas OSDU is focused on subsurface data.",
                                link: "platforms-osdu",
                                linkText: "View Details",
                            },
                        ];
                        break;
                    }
                    case "uda": {
                        this.singleSolutionsBox = [
                            {
                                icon: "/assets/img/funfacts/kepler.png",
                                title: "Kepler",
                                imageClass: "kepler",
                                paragraphText:
                                    "Engineers, analysts, data scientists, and others can use Kepler to initiate projects and evaluate new use cases from a strategic rather than transactional standpoint. Kepler allows teams to do what they do best – use data to tackle business challenges head-on.",
                                link: "platforms-kepler",
                                linkText: "View Details",
                            },
                            {
                                icon: "/assets/img/funfacts/mdp-logo-removebg-preview.png",
                                title: "MDP",
                                imageClass: "",
                                paragraphText:
                                    "An integrated and modern data platform that centralizes and exposes key unconventional datasets to end users amplifies the business value and enables acceleration of critical decisions and insights through analytics.",
                                link: "platforms-mdp",
                                linkText: "View Details",
                            },
                            {
                                icon: "/assets/img/funfacts/OSDU.png",
                                title: "OSDU",
                                imageClass: "",
                                paragraphText:
                                    "An industry-wide initiative to create a cloud-agnostic open subsurface environment. OSDU objectives are analogous to those of the Upstream Data Foundation (UDF) focused on surface and commercial data, whereas OSDU is focused on subsurface data.",
                                link: "platforms-osdu",
                                linkText: "View Details",
                            },
                        ];
                        break;
                    }
                    case "mdp": {
                        this.singleSolutionsBox = [
                            {
                                icon: "/assets/img/funfacts/kepler.png",
                                title: "Kepler",
                                imageClass: "kepler",
                                paragraphText:
                                    "Engineers, analysts, data scientists, and others can use Kepler to initiate projects and evaluate new use cases from a strategic rather than transactional standpoint. Kepler allows teams to do what they do best – use data to tackle business challenges head-on.",
                                link: "platforms-kepler",
                                linkText: "View Details",
                            },
                            {
                                icon: "/assets/img/funfacts/UDA.png",
                                title: "UDA",
                                imageClass: "",
                                paragraphText:
                                    "The Upstream Digital Accelerator (UDA) Data Platform, or The LakeHouse, is a system of reference developed and designed to join disparate data sources and provide simplified access to upstream data for Western Canadian Heavy Oil assets.",
                                link: "platforms-uda",
                                linkText: "View Details",
                            },
                            {
                                icon: "/assets/img/funfacts/OSDU.png",
                                title: "OSDU",
                                imageClass: "",
                                paragraphText:
                                    "An industry-wide initiative to create a cloud-agnostic open subsurface environment. OSDU objectives are analogous to those of the Upstream Data Foundation (UDF) focused on surface and commercial data, whereas OSDU is focused on subsurface data.",
                                link: "platforms-osdu",
                                linkText: "View Details",
                            },
                        ];
                        break;
                    }
                    case "osdu": {
                        this.singleSolutionsBox = [
                            {
                                icon: "/assets/img/funfacts/kepler.png",
                                title: "Kepler",
                                imageClass: "kepler",
                                paragraphText:
                                    "Engineers, analysts, data scientists, and others can use Kepler to initiate projects and evaluate new use cases from a strategic rather than transactional standpoint. Kepler allows teams to do what they do best – use data to tackle business challenges head-on.",
                                link: "platforms-kepler",
                                linkText: "View Details",
                            },
                            {
                                icon: "/assets/img/funfacts/mdp-logo-removebg-preview.png",
                                title: "MDP",
                                imageClass: "",
                                paragraphText:
                                    "An integrated and modern data platform that centralizes and exposes key unconventional datasets to end users amplifies the business value and enables acceleration of critical decisions and insights through analytics.",
                                link: "platforms-mdp",
                                linkText: "View Details",
                            },
                            {
                                icon: "/assets/img/funfacts/UDA.png",
                                title: "UDA",
                                imageClass: "",
                                paragraphText:
                                    "The Upstream Digital Accelerator (UDA) Data Platform, or The LakeHouse, is a system of reference developed and designed to join disparate data sources and provide simplified access to upstream data for Western Canadian Heavy Oil assets.",
                                link: "platforms-uda",
                                linkText: "View Details",
                            },
                        ];
                        break;
                    }
                }
            });
    }

    sectionTitle: sectionTitleContent[] = [
        {
            title: "Related Platforms",
        },
    ];
    singleSolutionsBox: solutionsBoxContent[] = [
        {
            icon: "/assets/img/funfacts/kepler.png",
            title: "Kepler",
            imageClass: "kepler",
            paragraphText:
                "Engineers, analysts, data scientists, and others can use Kepler to initiate projects and evaluate new use cases from a strategic rather than transactional standpoint. Kepler allows teams to do what they do best – use data to tackle business challenges head-on.",
            link: "platforms-kepler",
            linkText: "View Details",
        },
        {
            icon: "/assets/img/funfacts/mdp-logo.png",
            title: "MDP",
            imageClass: "",
            paragraphText:
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna adipiscing aliqua.",
            link: "platforms-mdp",
            linkText: "View Details",
        },
        {
            icon: "/assets/img/funfacts/UDA.png",
            title: "UDA",
            imageClass: "",
            paragraphText:
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna adipiscing aliqua.",
            link: "platforms-uda",
            linkText: "View Details",
        },
        {
            icon: "/assets/img/funfacts/OSDU.png",
            title: "OSDU",
            imageClass: "",
            paragraphText:
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna adipiscing aliqua.",
            link: "platforms-osdu",
            linkText: "View Details",
        },
    ];
}
class sectionTitleContent {
    title: string;
}
class solutionsBoxContent {
    icon: string;
    title: string;
    imageClass: string;
    paragraphText: string;
    link: string;
    linkText: string;
}
